export default function Schedule() {
  return <h1>Schedule</h1>;
}
